import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TuiDialogContext } from '@taiga-ui/core';
import { injectContext } from '@taiga-ui/polymorpheus';

@Component({
  selector: 'app-dialog-image-viewing',
  templateUrl: './dialog-image-viewing.component.html',
  styleUrls: ['./dialog-image-viewing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogImageViewingComponent {
  private readonly context = injectContext<TuiDialogContext<boolean, string>>();

  get src(): string {
    return this.context.data;
  }
}
